export const SELECT_NODE = 'SELECT_NODE';
export const DESELECT_NODE = 'DESELECT_NODE';
export const START_DELETING_NODE = 'START_DELETING_NODE';
export const STOP_DELETING_NODE = 'STOP_DELETING_NODE';
export const CLEAR_TREE = 'CLEAR_TREE';



// WEBPACK FOOTER //
// ./src/constants/TreeActionTypes.js